import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e3d27e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-wrapper" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "560",
    height: "315",
    src: "https://www.youtube-nocookie.com/embed/wCTM6_qRSsQ?si=UZoEWpINx_aZBiF-",
    title: "YouTube video player",
    frameborder: "0",
    allow: "encrypted-media;",
    allowfullscreen: ""
  })
], -1))

import { onMounted, ref } from 'vue'
import { ls } from '@/ls'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononVideoPopup',
  setup(__props) {

const showWoononVideo = ref(false)

onMounted(() => {
  if (!ls.get('woononVideoShown')) {
    showWoononVideo.value = true
    ls.set('woononVideoShown', true)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: showWoononVideo.value,
    width: _unref(generalStore)().desktop ? 800 : 520,
    closable: false,
    "body-style": { padding: 0 },
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (showWoononVideo.value = false))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showWoononVideo.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Sluiten")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["visible", "width"]))
}
}

})